module.exports = __webpack_public_path__ + "static/media/finance-smart.b4604c6d.svg";